/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S7_HeadingInputs */

const tr_kullanim_s7_heading = /** @type {(inputs: Kullanim_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Fikri Haklar`)
};

const en_kullanim_s7_heading = /** @type {(inputs: Kullanim_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Intellectual property rights`)
};

const de_kullanim_s7_heading = /** @type {(inputs: Kullanim_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Geistiges Eigentum`)
};

const ru_kullanim_s7_heading = /** @type {(inputs: Kullanim_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Права интеллектуальной собственности`)
};

/**
* | output |
* | --- |
* | "7. Intellectual property rights" |
*
* @param {Kullanim_S7_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s7_heading = /** @type {((inputs?: Kullanim_S7_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S7_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s7_heading(inputs)
	if (locale === "de") return de_kullanim_s7_heading(inputs)
	if (locale === "ru") return ru_kullanim_s7_heading(inputs)
	return tr_kullanim_s7_heading(inputs)
});